<template>
  <div
    class="tree-block"
    :draggable="!!isdraggable"
    @dragstart="dragstart($event)"
    @dragend="dragend($event)"
  >
    <div
      class="tree-row"
      @click="toggle"
      @mouseenter="enters(model[custom_field.id])"
      @mouseleave="leaver(model[custom_field.id])"
      :data-level="depth"
      :tree-id="model[custom_field.id]"
      :tree-p-id="model[custom_field.parent_id]"
      :class="{'highlight-row': model.highlight == true}"
      v-bind:style="{backgroundColor: model.backgroundColor}"
    >
      <column
        v-for="(subItem, subIndex) in columns"
        v-if="computedShow(subItem)"
        v-bind:class="['align-' + subItem.align, 'colIndex' + subIndex,
        {'flex-item':subItem.type !== 'selection'},{'module-item':!model.demandModuleId },'border-b',{'hover-item':currentId === model[custom_field.id] },
        {'col': /(.*)负责人$/.test(subItem.title)}]"
        :field="subItem.field"
        :width="subItem.width"
        :flex="subItem.flex"
        :border="border"
        :key="subIndex"
        :style="{'max-width': subItem.type == 'checkbox' ? '55px': ''}"
      >
        <span v-if="subItem.type === 'selection'" class="flex-name">
          <space :depth="depth" />
          <span
            v-if="model[custom_field.lists] && model[custom_field.lists].length"
            class="zip-icon"
            v-bind:class="[model[custom_field.open] ? 'arrow-bottom' : 'arrow-right']"
          ></span>
          <span v-else class="zip-icon arrow-transparent"></span>
          <span v-if="subItem.formatter" v-html="subItem.formatter(model)"></span>
          <span v-else-if="subItem.slot" style="display:flex">
            <span v-if="model.demandModuleId"><span style="font-weight:bold;">•</span><span class="underline" @click="detail(model)">{{model[subItem.field]}}</span></span>
            <span style="font-weight:bold;" v-else>{{model[subItem.field]}}<span v-show="!model.demandModuleId">({{model.demands}})</span></span>
            <span v-show="!model.demandModuleId && $_has('e-req')" @click.stop="showMenu(model,$event)">
              <svg t="1592272795253" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2826" width="32" height="32"><path d="M509.8 758.9c45.5 0.1 82.2 36.8 82.1 82.4-0.1 45.4-37 82.3-82.5 82.2-45.3 0-82.2-37.09999999-82.1-82.6 0.1-45.4 36.9-82 82.5-82z m-82.4-577c0-45.5 36.8-82.5 82.2-82.49999999 45.4-0.1 82.4 36.8 82.4 82.3 0 45.6-36.6 82.4-82.2 82.4s-82.4-36.6-82.4-82.20000001zM592 511.6c0 45.4-37.3 82.6-82.4 82.4-45.5-0.3-82.2-37.09999999-82.2-82.6 0-45.4 37.09999999-82.5 82.4-82.3 45.4 0.1 82.2 37 82.2 82.5z" p-id="2827" fill="#515151"></path></svg>
            </span>
          </span>
          <span v-else v-html="model[subItem.field]"></span>
        </span>
        <span v-else-if="subItem.type === 'action'">
          <a
            class="action-item"
            v-for="(acItem, acIndex) in subItem.actions"
            :key="acIndex"
            type="text"
            size="small"
            @click.stop.prevent="acItem.onclick(model)"
          >
            <i :class="acItem.icon" v-html="acItem.formatter(model)"></i>
          </a>
        </span>
        <span v-else-if="subItem.type === 'checkbox'">
          <input
            type="checkbox"
            v-if="model.isShowCheckbox !== false"
            :name="model[custom_field.id]"
            v-model="model[custom_field.checked]"
            class="checkbox action-item"
            @click.stop="onCheckboxClick($event, model)"
          />
        </span>
        <span v-else>
          <span v-if="subItem.formatter" v-html="subItem.formatter(model)"></span>
          <span v-else-if="subItem.slot" style="display:flex">
            <span style="font-weight:bold;">{{model[subItem.field]}}<span v-show="!model.demandModuleId">({{model.demands}})</span></span>
            <span v-show="!model.demandModuleId && $_has('e-req')" @click.stop="showMenu(model,$event)">
              <svg t="1592272795253" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2826" width="32" height="32"><path d="M509.8 758.9c45.5 0.1 82.2 36.8 82.1 82.4-0.1 45.4-37 82.3-82.5 82.2-45.3 0-82.2-37.09999999-82.1-82.6 0.1-45.4 36.9-82 82.5-82z m-82.4-577c0-45.5 36.8-82.5 82.2-82.49999999 45.4-0.1 82.4 36.8 82.4 82.3 0 45.6-36.6 82.4-82.2 82.4s-82.4-36.6-82.4-82.20000001zM592 511.6c0 45.4-37.3 82.6-82.4 82.4-45.5-0.3-82.2-37.09999999-82.2-82.6 0-45.4 37.09999999-82.5 82.4-82.3 45.4 0.1 82.2 37 82.2 82.5z" p-id="2827" fill="#515151"></path></svg>
            </span>
          </span>
          <span
          v-else-if="subItem.color1"
          :class="[{'warning':model[subItem.field]==2 || model[subItem.field]==3},{'success':model[subItem.field]==4}]">{{model[subItem.field]==1?'未分配':(model[subItem.field]==2?'进行中':(model[subItem.field]==3?'进行中':(model[subItem.field]==4?'已完成':(model[subItem.field]==5?'已中止':''))))}}</span>
          <el-tooltip v-else-if="subItem.time" offset="20" :visible-arrow="false" class="item" effect="dark" :content="model[subItem.field]" placement="top">
            <span>{{model[subItem.field]}}</span>
          </el-tooltip>
          <span
          v-else-if="subItem.color"
          :class="[{'warning':model[subItem.field]==1},{'success':model[subItem.field]==2}]">{{model[subItem.field]==1?'进行中':(model[subItem.field]==2?'已完成':(model[subItem.field]==3?'已中止':''))}}</span>
          <el-tooltip v-else-if="subItem.time" offset="20" :visible-arrow="false" class="item" effect="dark" :content="model[subItem.field]" placement="top">
            <span>{{model[subItem.field]}}</span>
          </el-tooltip>
          <span v-else>{{model[subItem.field]}}</span>

          </span>
          <span v-if="/(.*)负责人$/.test(subItem.title)" :class="[{'warning':model[columns[subIndex + 1].field]==1},{'success':model[columns[subIndex + 1].field]==2}]">
            {{model[columns[subIndex +1].field]==1?'进行中':(model[columns[subIndex + 1].field]==2?'已完成':(model[columns[subIndex + 1].field]==3?'已中止':''))}}</span>
      </column>
      <div class="hover-model" style="display: none">
        <div class="hover-block prev-block">
          <i class="el-icon-caret-top"></i>
        </div>
        <div class="hover-block center-block">
          <i class="el-icon-caret-right"></i>
        </div>
        <div class="hover-block next-block">
          <i class="el-icon-caret-bottom"></i>
        </div>
      </div>
    </div>
    <template v-if="isFolder">
      <row
        v-show="model[custom_field.open]"
        v-for="(item, index) in model[custom_field.lists]"
        :model="item"
        :columns="columns"
        :key="index"
        :isdraggable="isdraggable"
        :border="border"
        :depth="depth * 1 + 1"
        :custom_field="custom_field"
        :onCheck="onCheck"
        :isContainChildren="isContainChildren"
        v-on="$listeners"
        v-bind="$attrs"
      ></row>
    </template>
    <contextMenu ref="draggMenu">
      <ul class="nav-ctx-menu">
          <li @click="configOrg(1)">添加子模块</li>
          <li @click="configOrg(2)">创建需求</li>
          <!-- <li @click="configOrg(3)">设置上级</li> -->
          <!-- <li @click="configOrg(4)">设置负责人</li> -->
          <li @click="configOrg(3)">删除模块</li>
      </ul>
    </contextMenu>
  </div>
</template>
    <script>
import column from './column.vue'
import space from './space.vue'
export default {
  name: 'row',
  props: ['model', 'depth', 'columns', 'isdraggable', 'border', 'custom_field', 'onCheck', 'isContainChildren'],
  data () {
    return {
      open: false,
      visibility: 'visible',
      currentId:''
    }
  },
  components: {
    column,
    space
  },
  computed: {
    isFolder () {
      return this.model[this.custom_field.lists] && this.model[this.custom_field.lists].length
    },
    computedShow() {
      return function(item) {
        if(item.isShowFlag) {
        return false;
        } else {
          return true
        }
      }
    }
  },
  // watch:{
  //   model(){
  //     console.log(this.model,'model')
  //   }

  // },
  // created(){
  //   // this.$forceUpdate()
  //   console.log(this.columns,231,this.model)
  //   // this.$set(this.model,'update',1)
  // },
  methods: {
    toggle () {
      if (this.isFolder) {
        this.model[this.custom_field.open] = !this.model[this.custom_field.open];
        this.$forceUpdate()
      }
    },
    enters(e){
      this.currentId = e
    },
    leaver(e){
      this.currentId = ''
    },
    dragstart (e) {
      if (navigator.userAgent.indexOf('Firefox') >= 0) {
        // Firefox drag have a bug
        e.dataTransfer.setData('Text', this.id);
      }
      window.dragId = e.target.children[0].getAttribute('tree-id');
      window.dragPId = e.target.children[0].getAttribute('tree-p-id');
      window.dragParentNode = e.target;
      e.target.style.opacity = 0.2
    },
    dragend (e) {
      e.target.style.opacity = 1;
    },
    setAllCheckData (curList, flag) {
      const listKey = this.custom_field.lists
      for (let i = 0; i < curList.length; i++) {
        var item = curList[i]
        this.$set(item, 'checked', flag)
        if (item[listKey] && item[listKey].length) {
          this.setAllCheckData(item[listKey], flag)
        }
      }
    },
    onCheckboxClick (evt, model) {
      const list = model[this.custom_field.lists];
      // 判断是否有子节点，如有需递归处理
      if (list && this.isContainChildren) {
        this.setAllCheckData([model] || [], !!evt.target.checked)
      } else {
        this.$set(model, 'checked', !!evt.target.checked)
      }
      this.onCheck && this.onCheck()
    },
    showMenu(data,e){
      this.$emit('showMenu',data)
      this.$refs.draggMenu.open(e)
    },
    configOrg(e){
      if(e == 1){
        this.$emit('addChildModule',this.model)
      } else
      if(e == 2){
        this.$emit('createRequest',this.model)
      } else if(e == 3){
        this.$emit('deleteModule',this.model)
      }
    },
    detail(e){
      this.$router.push({name:'DemandDetail',query:{
        id:e.id,
        parent_id:e.parent_id,
        projectVersionId:this.$route.query.projectVersionId,
        projectId :this.$route.query.projectId
        }})
    }
  }
}
    </script>
  <style lang="scss">
.tree-block {
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
}
.tree-row {
  position: relative;
  display: flex;
  //   padding: 10px 10px;
  // border-bottom: 1px solid #eee;
  // line-height: 32px;
  // &:hover {
  //   background: #f5f7fa;
  // }
  &.highlight-row {
    background: #ffe88c;
  }
  .align-left {
    text-align: left;
  }
  .align-right {
    text-align: right;
  }
  .align-center {
    text-align: center;
  }
}
.hover-model {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
}
.hover-block {
  display: flex;
  opacity: 0.1;
  transition: opacity 0.5s;
  justify-content: center;
  align-items: center;
  i {
    color: #fff;
  }
}
.prev-block {
  height: 25%;
  background: #a0c8f7;
}
.center-block {
  height: 50%;
  background: #a0c8f7;
}
.next-block {
  height: 25%;
  background: #a0c8f7;
}
.action-item {
  color: #409eff;
  cursor: pointer;
  i {
    font-style: normal;
  }
}
.zip-icon {
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAf0lEQVQ4T7XT0Q2AMAhF0dvNdALdSEdzBB3BDXQD85LGRNMCauS7nAKBxMdIhfwemIAtYpeAEeiANoLUgAGYI4gFqAMX8QAXiQBCNFDNRBVdIgpUkSfADjT3KqLACmg/XrWw5J+Li+VVYCZrMBbgJluA+tXA3Hv45ZgiR3i+OQBeSyYRPEyeUAAAAABJRU5ErkJggg==")
    no-repeat center;
  background-size: cover;
}
.arrow-transparent {
  visibility: hidden;
}
// .arrow-right {
// }
.arrow-bottom {
  transform: rotate(90deg);
}
[draggable="true"] {
  -khtml-user-drag: element;
}
.icon{
    width: 18px;
    height: 18px;
    vertical-align: middle;
    cursor: pointer;
    // margin-left: 10px;
  }

        .nav-ctx-menu {
        padding: 0;
        list-style: none;
        background-color: #ffffff;
        font-size: 12px;
        line-height: 12px;
        text-align: left;
        color: #515a6e;
        li{
            border: 1px solid #dcdfe6;
            border-bottom: none;
            padding: 8px 20px;
            cursor: pointer;
        }

        li:last-child{
             border-bottom: 1px solid #dcdfe6;
        }

        li:hover{
            background-color: #dcdfe6;
        }

    }
    .flex-name{
      display: flex;
      align-items: center;
    }
    .flex-item{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .border-b{
      border-bottom: 1px solid #dcdfe6;
    }
    .module-item{
      background: #f5f7fa;
    }
    .underline{
      text-decoration: underline;
      cursor: pointer;
    }
    .hover-item{
      background: #eee;
    }
    .warning{
      color: #E6A23C;
    }
    .success{
      color: #67C23A;
    }
    .col {
      flex-direction: column;
    }
</style>



// WEBPACK FOOTER //
// src/components/dragTreeTable/row.vue